import {text_mod_63, } from "../text/Text.js";
export const module63 = {
  title:
    "§63. Текст-розповідь",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_63, },
    ]
  }
